import { StyleSheet } from 'react-native';
import { PRIMARY_COLOR } from 'coooltv-js-shared/src/styles/common';
import { GREY_COLOR } from '../../styles/common';

const styles = StyleSheet.create({
    wrapper: {
        borderTopWidth: 1,
        borderRightStyle: 'solid',
        borderColor: PRIMARY_COLOR,
        display: 'flex',
        marginTop: -2,
        paddingTop: 90,
        paddingHorizontal: 30,
        flexDirection: 'column',
        justifyContent: 'center',
    },
    wrapper_phone: {
        borderTopWidth: 1,
        borderRightStyle: 'solid',
        borderColor: PRIMARY_COLOR,
        display: 'flex',
        marginTop: -2,
        paddingTop: '20%',
        paddingHorizontal: 15,
        flexDirection: 'column',
        justifyContent: 'center',
        paddingBottom: 50,
    },
    internal_wrapper: {
        marginVertical: 60,
        alignSelf: 'center',
    },
    internal_wrapper_phone: {
        marginTop: 20,
        width: '100%',
        alignSelf: 'center',
    },
    text: {
        fontSize: 24,
        color: GREY_COLOR,
    },
    text_phone: {
        fontSize: 18,
        color: GREY_COLOR,
    },
    text_wrapper: {
        alignItems: 'center',
        paddingBottom: '2%',
    },
});

export default styles;
